import { ReadonlyRecord } from '@bimser/core';
import { Record } from 'immutable';
import { Details, DetailsFactory, DetailsFactoryFromJS, IDetails } from './IDetails';

export interface IBaseDetailsContent {
	isCalculated: boolean;
	calculating: boolean;
}

export interface IDetailsContent extends IBaseDetailsContent {
	data: IDetails;
}

export interface IReadonlyDetailsContent extends IBaseDetailsContent {
	data: Details;
}

export type DetailsContent = ReadonlyRecord<IReadonlyDetailsContent>;

export const DetailsContentFactory = Record<IReadonlyDetailsContent>({
	isCalculated: false,
	calculating: false,
	data: DetailsFactory()
});

export const DetailsContentFactoryFromJS = (data: IDetailsContent): DetailsContent =>
	DetailsContentFactory({
		...data,
		data: DetailsFactoryFromJS(data.data)
	});
